export const HEADER_TITLE = {
  '/lists/contact-lists': 'Lists',
  '/lists/account-lists': 'Lists',
  '/holdings/search': 'Holdings',
  '/accounts': 'Accounts',
};

export const RECENT_ACTIVITIES_HEADER = 'Recent Activities';
export const UPCOMING_ACTIVITIES_HEADER = 'Upcoming Activities';
